import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  retry: {
    id: 'studio.62nsdy',
    defaultMessage: 'Retry',
  },
});
